"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollaboratorItem = void 0;
exports["default"] = CollaboratorFormatter;

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _AddRounded2 = _interopRequireDefault(require("@material-ui/icons/AddRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _AccountCircle2 = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _propTypes2 = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CollaboratorItem = function CollaboratorItem(_ref) {
  var data = _ref.data,
      onDelete = _ref.onDelete;
  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      height: "100%"
    },
    alignItems: "center",
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
    size: "small",
    label: "".concat(data.firstName, " ").concat(data.lastName || ""),
    icon: /*#__PURE__*/_react["default"].createElement(_AccountCircle2["default"], {
      style: {
        color: "#20C933"
      }
    }),
    onDelete: onDelete
  }));
};

exports.CollaboratorItem = CollaboratorItem;
CollaboratorItem.propTypes = {
  onDelete: _propTypes["default"].func,
  data: _propTypes["default"].object
};
CollaboratorFormatter.propTypes = _propTypes2.EditorProps;

function CollaboratorFormatter(_ref2) {
  var row = _ref2.row,
      column = _ref2.column,
      isCellSelected = _ref2.isCellSelected;
  var isEditable = column.isEditable,
      options = column.options,
      onClickAdd = column.onClickAdd,
      onClickDelete = column.onClickDelete;
  var relationship = (options === null || options === void 0 ? void 0 : options.relationship) || "one";
  var value = row[column.key];
  var id = row["id"] || row["_id"];

  var handleAdd = function handleAdd(e) {
    if (typeof onClickAdd === "function") {
      onClickAdd({
        value: value,
        row: row,
        column: column,
        currentTarget: e.currentTarget,
        variant: "add"
      });
    }
  };

  var handleDelete = function handleDelete(item) {
    if (typeof onClickAdd === "function") {
      onClickDelete({
        value: value,
        item: item,
        row: row,
        column: column
      });
    }
  };

  if (Array.isArray(value)) {
    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      display: "flex",
      alignItems: "center",
      onClick: isEditable && isCellSelected && value.length === 0 ? handleAdd : null,
      style: {
        height: "100%",
        position: "relative"
      }
    }, relationship === "one" && value.length >= 1 || id === "create" ? null : isCellSelected && isEditable ? /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
      variant: "contained",
      style: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        borderRadius: "0.25rem",
        zIndex: 1,
        padding: 0,
        marginRight: 2,
        marginLeft: -2,
        minWidth: 16,
        height: 16
      },
      onClick: handleAdd
    }, /*#__PURE__*/_react["default"].createElement(_AddRounded2["default"], {
      style: {
        fontSize: 14
      }
    })) : null, value.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(CollaboratorItem, {
        key: item._id || item.id,
        data: item,
        onDelete: isEditable && isCellSelected ? function () {
          return handleDelete(item, index);
        } : null
      });
    }));
  }

  return null;
}